import { CsvImportStatus } from 'IntegrationModule/types';

export const MappingStatusDataCell = ({
  mappingStatus,
}: Pick<CsvImportStatus, 'mappingStatus'>) => {
  return (
    <div>
      {mappingStatus
        ? Object.entries(mappingStatus).map(([dataType, statusCounts]) => (
            <div key={dataType}>
              <b>{dataType}</b>
              {statusCounts &&
                Object.entries(statusCounts).map(([statusKey, count]) => (
                  <p key={statusKey}>
                    {statusKey}: {count}
                  </p>
                ))}
            </div>
          ))
        : 'N/A'}
    </div>
  );
};
